import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-2 bg-white p-5 pt-8"
}
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between pb-2" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x d-flex align-items-center" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "text-sm ms-3 font-semibold d-none" }
const _hoisted_7 = { class: "border-bottom pb-2 mt-5" }
const _hoisted_8 = { class: "text-sm font-semibold" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "form-label text-gray-500 font-light mt-3"
}
const _hoisted_11 = {
  key: 1,
  class: "d-flex flex-wrap gap-2 keywords-filter-section"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "form-label text-gray-500 font-light mt-3" }
const _hoisted_14 = { class: "d-flex flex-wrap gap-2 keywords-filter-section" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "form-label text-gray-500 font-light mt-3"
}
const _hoisted_17 = {
  key: 3,
  class: "d-flex flex-wrap gap-2 keywords-filter-section"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "border-bottom pb-2 mt-5" }
const _hoisted_21 = { class: "text-sm font-semibold" }
const _hoisted_22 = {
  key: 0,
  class: "form-group"
}
const _hoisted_23 = { class: "form-label text-gray-500 font-light mt-3" }
const _hoisted_24 = { class: "d-flex flex-wrap gap-2 keywords-filter-section" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "form-group"
}
const _hoisted_27 = { class: "form-label text-gray-500 font-light mt-3" }
const _hoisted_28 = { class: "d-flex flex-wrap gap-2 keywords-filter-section" }
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_ctx.$store.state.filtersOpened === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "d-flex btn btn-outlined-gray-100 nav-link align-items-center p-1",
              style: {"font-size":"1.125rem"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_ctx.$store.dispatch('set', {
							stateProperty: 'filtersOpened',
							value: false,
						})
					))
            }, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('expressions', 'Filters_Title'))), 1)
          ]),
          _createVNode(_component_ButtonComponent, {
            label: 
					_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Apply_Filters'))
				,
            class: _normalizeClass(["btn-sm py-1 px-2 text-nowrap ms-2", 
					_ctx.saveButtonDisabled === true ? 'btn-outline-success' : 'btn-success'
				]),
            ref: "saveButton",
            disabled: _ctx.saveButtonDisabled === true,
            loading: _ctx.isSubmittingFilters === true,
            type: "submit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveButtonDisabled === false ? _ctx.handleSubmit() : ''))
          }, null, 8, ["label", "class", "disabled", "loading"])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("header", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Filters_Title_Contents')
					)), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.$route.name === _ctx.$config('RouteConfig', 'PostsRouteName') || _ctx.isSocialView())
              ? (_openBlock(), _createElementBlock("label", _hoisted_10, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
                _ctx.$text('expressions', 'Filters_Subtitle_Social_Source')
            )), 1))
              : _createCommentVNode("", true),
            (_ctx.$route.name === _ctx.$config('RouteConfig', 'PostsRouteName')  || _ctx.isSocialView())
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$config('AppConfig', 'SocialSources'), (source, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: index,
                      class: _normalizeClass(["rounded text-sm px-2", 
							_ctx.filters.social_source && _ctx.filters.social_source.includes(source)
								? 'text-white'
								: ''
						]),
                      style: _normalizeStyle(
							_ctx.filters.social_source && _ctx.filters.social_source.includes(source)
								? 'background-color: #5C60F5'
								: ''
						),
                      onClick: ($event: any) => (_ctx.switchSocialSource(source))
                    }, _toDisplayString(source), 15, _hoisted_12))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Filters_Subtitle_Languages')
					)), 1),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$config('AppConfig', 'FiltersLanguages'), (language, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  class: _normalizeClass(["rounded text-sm px-2", 
							_ctx.filters.languages && _ctx.filters.languages.includes(language)
								? 'text-white'
								: ''
						]),
                  style: _normalizeStyle(
							_ctx.filters.languages && _ctx.filters.languages.includes(language)
								? 'background-color: #5C60F5'
								: ''
						),
                  onClick: ($event: any) => (_ctx.switchLanguages(language))
                }, _toDisplayString(language), 15, _hoisted_15))
              }), 128))
            ]),
            (_ctx.$route.name !== _ctx.$config('RouteConfig', 'PostsRouteName') && !_ctx.isSocialView())
              ? (_openBlock(), _createElementBlock("label", _hoisted_16, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Filters_Subtitle_Categories')
					)), 1))
              : _createCommentVNode("", true),
            (_ctx.$route.name !== _ctx.$config('RouteConfig', 'PostsRouteName')  && !_ctx.isSocialView())
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$config('AppConfig', 'FiltersCategories'), (category, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: index,
                      class: _normalizeClass(["rounded text-sm px-2", 
							_ctx.filters.categories && _ctx.filters.categories.includes(category)
								? 'text-white'
								: ''
						]),
                      style: _normalizeStyle(
							_ctx.filters.categories && _ctx.filters.categories.includes(category)
								? 'background-color: #5C60F5'
								: ''
						),
                      onClick: ($event: any) => (_ctx.switchCategories(category))
                    }, _toDisplayString(category), 15, _hoisted_18))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.$store.state.filters && _ctx.$store.state.filters.keywords)
          ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
              _createElementVNode("header", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Filters_Title_Keywords')
					)), 1)
              ]),
              (
					_ctx.$store.state.filters.keywords.message &&
					_ctx.$store.state.filters.keywords.message.length > 0
				)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Filters_Subtitle_Message_Keywords')
					)), 1),
                    _createElementVNode("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.filters.keywords.message, (keyword, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          class: _normalizeClass(["rounded text-sm px-2", 
							_ctx.filters.keyword_ids && _ctx.filters.keyword_ids.includes(keyword._id)
								? 'text-white'
								: ''
						]),
                          style: _normalizeStyle(
							_ctx.filters.keyword_ids && _ctx.filters.keyword_ids.includes(keyword._id)
								? 'background-color:' + keyword.color
								: ''
						),
                          onClick: ($event: any) => (_ctx.switchKeyword(keyword._id))
                        }, _toDisplayString(keyword.name), 15, _hoisted_25))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
					_ctx.$store.state.filters.keywords.spoke &&
					_ctx.$store.state.filters.keywords.spoke.length > 0
				)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
						_ctx.$text('expressions', 'Filters_Subtitle_Spoke_Keywords')
					)), 1),
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.filters.keywords.spoke, (keyword, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          class: _normalizeClass(["rounded text-sm px-2", 
							_ctx.filters.keyword_ids && _ctx.filters.keyword_ids.includes(keyword._id)
								? 'text-white'
								: ''
						]),
                          style: _normalizeStyle(
							_ctx.filters.keyword_ids && _ctx.filters.keyword_ids.includes(keyword._id)
								? 'background-color:' + keyword.color
								: ''
						),
                          onClick: ($event: any) => (_ctx.switchKeyword(keyword._id))
                        }, _toDisplayString(keyword.name), 15, _hoisted_29))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}